<script setup lang="ts">
import type { Article } from "~/types/article"

const { length = "Laster...", title = "Laster..." } = defineProps<{
  length?: string
  title?: string
  img: Article["img"]
}>()

const videoLength = computed(() => getMinutesAndSeconds(length, ""))
</script>

<template>
  <div
    class="flex size-full flex-col overflow-clip rounded-2xl bg-darker text-white"
  >
    <h3
      class="p-4 font-national2condensed text-2xl font-medium lg:p-8 lg:text-4xl xl:text-5xl"
      v-text="title"
    />

    <div
      class="flex size-full flex-col"
      :class="{ 'bg-black': !img?.src }"
    >
      <div class="grow-1 relative size-full">
        <img
          v-if="img?.src"
          :src="img.src"
          :alt="img.alt"
          class="size-full object-cover"
        />

        <div
          class="absolute left-8 top-8 flex items-center justify-center gap-2 rounded-lg bg-[--theme-darker] p-2 px-4 pr-5 font-national2 text-xl font-bold lg:text-2xl"
        >
          <UIcon name="play-filled" />
          <span v-if="videoLength" v-text="videoLength" />
        </div>
      </div>
    </div>
  </div>
</template>
